import { LOGINUNICO_TOKEN } from '../../constants/ActionTypes';

/**
 * Get is_active.
 * @function loginUnicoToken
 * @param {string} code code.
 * @param {state} state state.
 * @returns {Object} Get loginunico_token
 */
export function loginUnicoToken(code, state) {
  return {
    type: LOGINUNICO_TOKEN,
    request: {
      op: 'get',
      path: `/@loginunico-token?code=${code}&state=${state}`,
    },
  };
}